var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0ZM4.32059 7.45422H6.36019V13.5824H4.32059V7.45422ZM6.4945 5.55851C6.48126 4.95765 6.05158 4.5 5.35385 4.5C4.65612 4.5 4.19996 4.95765 4.19996 5.55851C4.19996 6.14693 4.64264 6.61776 5.32737 6.61776H5.34041C6.05158 6.61776 6.4945 6.14693 6.4945 5.55851ZM11.3674 7.3103C12.7096 7.3103 13.7158 8.18636 13.7158 10.0687L13.7157 13.5823H11.6762V10.3038C11.6762 9.48028 11.381 8.91835 10.6427 8.91835C10.0792 8.91835 9.74358 9.29717 9.59617 9.66307C9.54224 9.7942 9.529 9.9769 9.529 10.16V13.5825H7.48916C7.48916 13.5825 7.51604 8.0294 7.48916 7.45437H9.529V8.32237C9.7997 7.9051 10.2845 7.3103 11.3674 7.3103Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinLogo);
export default __webpack_public_path__ + "static/media/linkedin_logo.3749a24bfa28511d43d8d20795d43cd6.svg";
export { ForwardRef as ReactComponent };